import { Component, OnInit, SimpleChanges, Input, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivityService } from 'app/services/activity.service';

interface DisplayObj  {
	displayType: 'string' | 'array';
	coords: any;
}

@Component({
	selector: 'app-feature-coordinates-display',
	templateUrl: './feature-coordinates-display.component.html',
	styleUrls: ['../feature-geojson-unit/feature-geojson-unit.component.css', './feature-coordinates-display.component.css']
})
export class FeatureCoordinatesDisplayComponent implements OnInit, OnChanges {

	
	@Input() coordinates: any[] = [];
	@Input() featType!: string;

	displayObj!: DisplayObj;

	@Input() isExpand = true;

	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService
	) { }

	onMouseoverCoord(coordStr: string) {
		try {
			const coord = JSON.parse(coordStr);
			this.activityService.hoverCoord.next({
				coord: coord
			});
		} catch (err) {
			console.log(err);
			this.toastr.error(err.message);
		}
	}
	onMouseoutCoord() {
		this.activityService.hoverCoord.next({
			coord: null
		});
	}

	private transformToDisplay(coordinates: any[]) {
		let obj: DisplayObj = {
			displayType: 'string',
			coords: ''
		};

		if (coordinates) {
			if (typeof coordinates[0] === 'number') {
				obj = {
					displayType: 'string',
					coords: JSON.stringify(coordinates)
				};
			} else if (Array.isArray(coordinates[0])) {
				obj = {
					displayType: 'array',
					coords: coordinates
				};
			}
		}
		this.displayObj = obj;
	}
	private transformCoordinatesToDisplay(coordinates: any[], parent: any[]) {
		if (coordinates[0] && typeof coordinates[0][0] === 'number') {
			const strList: string[] = [];
			coordinates.forEach(coords => {
				strList.push(JSON.stringify(coords));
			});
			parent.push(strList);
		} else if (coordinates[0] && Array.isArray(coordinates[0][0])) {
			coordinates.forEach(coords => {
				const subParent: any[] = [];
				parent.push(subParent);
				this.transformCoordinatesToDisplay(coords, subParent);
			})
		}
	}
	private onCoordinatesChange() {
		try {
			this.transformToDisplay(this.coordinates);
		} catch (err) {
			this.toastr.info('Invalid Format');
		}
	}
	ngOnInit(): void {
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.coordinates) {
			this.onCoordinatesChange();
		}
	}

}
